a.location.changes = (function(){
	var my = {
		page:function(o){
			o.is_popup = false;
			o.win = $('#content');
			a.page({tpl:'location/changes/page',data:{
				is_popup:o.is_popup
			},ready:function(){
				my.init(o);
			}});
		},
		popup:function(o){
			o.is_popup = true;
			var token = a.popup.create({
				slideFrom:'fromleft',
				title:'Location changes',
				ready:function(token){
					var win = $('#popupid_'+token);
					o.win = win;
					tpl.run({tpl:'/tpl/location/changes/page.ejs?v='+v,data:{
						is_popup:o.is_popup
					},cb:function(c){
						$('>.ic',o.win).empty().append(c).ready(function(){
							my.init(o);
						});
					}});
				}
			});
		},
		init:function(o){
			var iid = o.iid || null;
			var cb_back = o.back || function(){
				location.hash='/';
			}
			$('*[data-action="back"]').unbind('click').click(function(){
				cb_back();
			});
			// Load default
			my.loadList({
				offset:0,
				direction:'down',
				iid:iid
			},o);
		},
		loadList:function(filter,o){
			filter.token = localStorage.getItem('token');
			filter.accountname = localStorage.getItem('accountname');
			$.ajax({
				type:'GET',
				url:'/api/location/changes/',
				data:filter,
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success && result.list) {
						tpl.run({
							tpl:'/tpl/location/changes/list.ejs?v='+v,
							data:result,
							cb:function(c){
								$('div[data-area="result"]',o.win).empty().append(c).ready(function(){
									my.initResult();
								});
							}
						});
						tpl.run({tpl:'/tpl/location/changes/pagination.ejs?v='+v,data:result.pagination,cb:function(paginationcontent){
							$('[data-area="pagination"]',o.win).empty().append(paginationcontent).ready(function(){
								$('[data-area="pagination"] a[data-action="paginate"]').unbind('click').click(function(){
									filter.offset = $(this).attr('data-offset');
									my.loadList(filter,o);
								});
							});
						}});
						$(window).scrollTop(0);
					}
					else {
						$('div[data-area="pagination"]').empty();
						tpl.run({tpl:'/tpl/shared/nohits.ejs?v='+v,data:{},cb:function(content){
							$('[data-area="result"]',o.win).empty().append(content);
						}});
					}
				}
			}).done(function(){
				
			});
		},
		initResult:function(){
			$('li[data-action="display-lc"]').unbind('click').click(function(){
				
			});
		}
	}
	return my;
}());